// extracted by mini-css-extract-plugin
export default {"quizTimeText":"quiz-content-module--quizTimeText--f7eec","text":"quiz-content-module--text--3ba4c"};